import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scrolls the window to the top on client-side route changes (SPA default keeps scroll position).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation()

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
